import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "B肝報告",
    isNumber: true,
  },
];

export const CheckAreaToHepatitisB = {
  label: "篩檢場域 VS B肝",
  key: "CheckAreaToHepatitisB",
  path: "HepatitisTracking/CheckAreaToHepatitisB",
  api: "TCS_V_LiverS021",
  render: (options) => (
    <Diagram.HepatitisTracking.CheckAreaToHepatitisB {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "篩檢場域",
      field: "篩檢場域",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
